import { Component, Input, OnInit } from '@angular/core';
import { MktEnvironmentService } from 'src/app/core/services/mkt-environment.service';
import { MktModalService } from 'src/app/core/services/mkt-modal.service';

@Component({
  selector: 'app-credit-card-conversion-footer',
  templateUrl: './credit-card-conversion-footer.component.html',
  styleUrls: ['./credit-card-conversion-footer.component.scss'],
  standalone: false,
})
export class CreditCardConversionFooterComponent implements OnInit {
  showModal: boolean = false;
  date;
  url: string;
  @Input() footerContent: any;
  public imagePrefix: string;
  private cbolUrl: string;
  constructor(private mktEnvironmentService: MktEnvironmentService,
    private modalService: MktModalService) {
    this.date = new Date();
    this.imagePrefix = this.mktEnvironmentService.getEnvironmentVar('cardsmkrHostName');
    this.cbolUrl = this.mktEnvironmentService.getEnvironmentVar('CBOL_URL');
  }

  ngOnInit() {
    this.footerContent.links.map(link => {
      link.linkURL = (['about_us', 'sitemap'].includes(link.key)) ? link.linkURL : `${this.cbolUrl}${link.linkURL}`;
    });
  }

  onFooterClick() {
    window.scroll(0, 0)
  }

  openModal(event, categoryIndex, categoryItemIndex) {
    event.preventDefault();
    if (event?.type === 'mouseup') {
      const button = event?.which;
      if (button !== 1 && button !== 2) return;
    }

    const socialCategory = this.footerContent.footerCategories[categoryIndex];
    const socialCategoryItem = socialCategory.footerCategoryItems[categoryItemIndex];

    this.modalService.openModal(event, {
      url: socialCategoryItem.primaryActionUrl,
      title: socialCategoryItem.modalTitle,
      content: socialCategoryItem.body,
      primaryButtonText: socialCategoryItem.buttonTitle,
      target: event.currentTarget.target || '_blank'
    });
  }
}
